// src/pages/About.js
import React from "react";
import { NavLink } from "react-router-dom";

// Breadcrumb / Hero Title
const Breadcrumb = () => (
  <div
    className="optech-breadcrumb"
    style={{ backgroundImage: "url(/assets/images/breadcrumb/breadcrumb.png)" }}
  >
    <div className="container">
      <h1 className="post__title">About Us</h1>
      <nav className="breadcrumbs">
        <ul>
          <li><NavLink to="/">Home</NavLink></li>
          <li aria-current="page">About Us</li>
        </ul>
      </nav>
    </div>
  </div>
);

// Intro Section
const AboutIntro = () => (
  <section className="section large-padding-tb overflow-hidden">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="optech-thumb extra-mr">
            <img
              data-aos="fade-up"
              data-aos-duration="600"
              src="/assets/images/v1/thumb1.png"
              alt=""
            />
            <div
              className="optech-thumb-position"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <img src="/assets/images/v1/thumb2.png" alt="" />
            </div>
            <div className="optech-shape1">
              <img src="/assets/images/shape/shape1.svg" alt="" />
            </div>
            <div className="optech-shape2">
              <img src="/assets/images/shape/shape2.svg" alt="" />
            </div>
          </div>
        </div>
        <div className="col-lg-6 d-flex align-items-end">
          <div className="optech-default-content ml40">
            <h2>Welcome To R.A. Inc.</h2>
            <h5>Empowering Global Communication Through Language</h5>
            <p>
              At R.A. Inc., we deliver professional translation and localization
              services that bridge the language and understanding gap. We offer
              precise, culturally relevant translations across various sectors,
              including legal, medical, technical, and business communication.
              Our team of linguists and industry-specific experts specializes in
              translation work for legal, technical, marketing, and medical
              purposes. Whether document translation, website localization,
              multimedia translation, etc., our work will always keep the
              original quality of your message intact so that it relates to
              native target audiences.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section> /* :contentReference[oaicite:0]{index=0}&#8203;:contentReference[oaicite:1]{index=1} */
);

// Mission / Vision / Values Section
const CultureSection = () => (
  <section className="section large-padding-tb2 overflow-hidden bg-light1">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 order-lg-2">
          <div className="optech-thumb extra-ml">
            <img
              data-aos="fade-up"
              data-aos-duration="600"
              src="/assets/images/v3/thumb3.png"
              alt=""
            />
            <div
              className="optech-thumb-position2"
              data-aos="fade-up"
              data-aos-duration="800"
            >
              <img src="/assets/images/v3/thumb4.png" alt="" />
            </div>
            <div className="optech-shape3">
              <img src="/assets/images/shape/shape3.svg" alt="" />
            </div>
            <div className="optech-shape4">
              <img src="/assets/images/shape/shape2.svg" alt="" />
            </div>
          </div>
        </div>
        <div className="col-lg-6 d-flex align-items-center">
          <div className="optech-default-content mr40">
            <h2>Get Started with Culturally Precise Translations</h2>
            <div className="optech-extra-mt">
              {[
                {
                  icon: "icon10.svg",
                  title: "Our Mission",
                  link: "/contact-us",
                  text:
                    "Our mission is to remove language barriers so everyone and every organization can communicate clearly, confidently, and effectively across borders and cultures."
                },
                {
                  icon: "icon1.svg",
                  title: "Our Vision",
                  link: "/team",
                  text:
                    "Our goal is a world where language is not a barrier but a gateway to unlimited opportunities and genuine relationships worldwide."
                },
                {
                  icon: "icon2.svg",
                  title: "Our Values",
                  link: "/contact-us",
                  text:
                    "Our goal is to always provide high-quality translations that fulfill our customers' needs and exceed their expectations with quality, professionalism, and integrity."
                }
              ].map(({ icon, title, link, text }) => (
                <div key={title} className="optech-iconbox-wrap2 mb-0">
                  <div className="optech-iconbox-icon2 bg-white">
                    <img src={`/assets/images/iconbox/${icon}`} alt={title} />
                  </div>
                  <div className="optech-iconbox-data2">
                    <NavLink to={link}>
                      <h5>{title}</h5>
                    </NavLink>
                    <p>{text}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  </section> /* :contentReference[oaicite:2]{index=2}&#8203;:contentReference[oaicite:3]{index=3} */
);

// Counter Section
const CounterSection = () => (
  <section className="section optech-section-padding-bottom">
    <div className="container">
      <div id="optech-counter" />
      <div
        className="optech-counter-wrap"
        style={{ backgroundImage: "url(/assets/images/v2/counter-bg.png)" }}
      >
        {[
          { icon: "icon1.svg", value: 55, suffix: "+", label: "Happy Clients" },
          { icon: "icon2.svg", value: 46, suffix: "+", label: "Finished Projects" },
          { icon: "icon3.svg", value: 13, suffix: "+", label: "Skilled Linguists" },
          { icon: "icon4.svg", value: 5, suffix: "%", label: "Year Experience" }
        ].map(({ icon, value, suffix, label }) => (
          <div key={label} className="optech-counter-data" data-aos="fade-up">
            <div className="optech-counter-icon">
              <img src={`/assets/images/v2/${icon}`} alt={label} />
            </div>
            <div className="optech-counter-number">
              <span data-percentage={value} className="optech-counter"></span>
              {suffix}
            </div>
            <p>{label}</p>
          </div>
        ))}
      </div>
    </div>
  </section> /* :contentReference[oaicite:4]{index=4}&#8203;:contentReference[oaicite:5]{index=5} */
);

// Testimonials Section
const Testimonials = () => (
  <section className="section optech-section-padding bg-light1">
    <div className="container">
      <div className="optech-section-title center">
        <h2>What Our Customers Say</h2>
      </div>
      <div className="optech-2column-slider" data-aos="fade-up" data-aos-duration="600">
        {[
          {
            quote:
              "We had some fairly complex technical manuals and the R.A. Inc. team were really sharp on those. They were familiar with the industry terms and provided correct and easy to understand translations. Fantastic work!",
            name: "James Nolan",
            role: "Product Lead"
          },
          {
            quote:
              "I wanted some urgent translations on professional documentations for my business and R.A. Inc. exceeded my expectations. The translations were precise, culturally appropriate, and within the deadline. Highly recommend!",
            name: "Alexander Cameron",
            role: "Marketing Head"
          },
          {
            quote:
              "Working with R.A. Inc. was a seamless experience. Their attention to detail and commitment to quality helped us launch our product globally with confidence. I couldn’t be happier with their service!",
            name: "Brooklyn Simmons",
            role: "Lead Developer"
          },
          {
            quote:
              "For my immigration process I needed certified translation and was impressed by the speed and professionalism of R.A. Inc. The documents were readily accepted. To say the least, the process went smoothly.",
            name: "David Mitchell",
            role: "Operations Manager"
          }
        ].map(({ quote, name, role }) => (
          <div key={name} className="optech-t-box">
            <div className="optech-t-quote">
              <img src="/assets/images/v1/quote.svg" alt="quote" />
            </div>
            <div className="optech-t-data">
              <p>“ {quote} ”</p>
              <div className="optech-t-rating">
                <ul>
                  {Array.from({ length: 5 }).map((_, i) => (
                    <li key={i}>
                      <img src="/assets/images/v1/rating.svg" alt="" />
                    </li>
                  ))}
                </ul>
              </div>
              <div className="optech-t-author">
                <h5>{name}</h5>
                <span>{role}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section> /* :contentReference[oaicite:6]{index=6}&#8203;:contentReference[oaicite:7]{index=7} */
);

// Call-To-Action Section
const CTASection = () => (
  <section
    className="section bg-cover optech-section-padding"
    style={{ backgroundImage: "url(/assets/images/cta/cta-bg2.png)" }}
  >
    <div className="container">
      <div className="optech-cta-wrap">
        <div className="optech-cta-content center">
          <h2>Let's Translate Your Vision Into Every Language</h2>
          <p>
            Whether you're expanding your business internationally or need
            multilingual content for local markets, we provide solutions tailored
            to your goals, audience, and tone.
          </p>
          <div className="optech-extra-mt" data-aos="fade-up" data-aos-duration="800">
            <NavLink className="optech-default-btn" data-text="Let’s Start a Project" to="/contact-us">
              <span className="btn-wraper">Let’s Start a Project</span>
            </NavLink>
          </div>
        </div>
      </div>
    </div>
  </section> /* :contentReference[oaicite:8]{index=8}&#8203;:contentReference[oaicite:9]{index=9} */
);

const About = () => (
  <>
    <Breadcrumb />
    <AboutIntro />
    <CultureSection />
    <CounterSection />
    <Testimonials />
    <CTASection />
  </>
);

export default About;